import React, {useState, useEffect, useRef} from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";

function Contact(props) {
    const [contactdetails, setcontactdetails] = useState({fname: "", lname: "", email: "", number: "", message: ""})
    const host = process.env.REACT_APP_HOST;
    const recaptchaRef = useRef()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const maxLengthCheck = (e) => {
      if(e.target.value.length > e.target.maxLength) {
          e.target.value = e.target.value.slice(0, e.target.maxLength)
      }
    }

    const onChange = (e) => {
        setcontactdetails({...contactdetails, [e.target.name]: e.target.value})
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const recaptchaValue = recaptchaRef.current.getValue();
        if(contactdetails.fname === "" || contactdetails.lname === "" || contactdetails.email === "" || contactdetails.number === "" || contactdetails.message === ""){
            toast.error('Please Fill Up All the Required Fields', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0,
            })
        } else if(recaptchaValue === "") {
            toast.error('Invalid Captcha', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
        } else {
            props.setloader(true)
            const response = await fetch(`${host}/api/contact`, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({fname: contactdetails.fname, lname: contactdetails.lname, email: contactdetails.email, mobile: contactdetails.number, message: contactdetails.message })
            })
            const json = await response.json();
            if(json.success) {
                setcontactdetails({fname: "", lname: "", email: "", mobile: "", message: ""})
                props.setloader(false)
                toast.success('Sent Successfully. We will get in touch shortly', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: 0,
                })
            } else {
                props.setloader(false)
                toast.error('There was some error while sending your query', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: 0,
                })
            }
        }
        console.log("Submitted")
    }
  return (
      <>
    <ToastContainer />
    <section className="text-gray-600 body-font relative">
        <div className="container px-5 py-24 mx-auto">
            <div className="flex flex-col text-center w-full mb-16">
                <p className="text-md my-2 font-semibold text-088AB2 w-full">Contact Us</p>
                <h1 className="text-4xl font-semibold title-font mb-4 text-gray-900">Get in touch</h1>
                <p className="lg:w-2/3 mx-auto leading-relaxed text-667085">We’d love to hear from you. Please fill out this form.</p>
            </div>
            <div className="lg:w-1/2 md:w-2/3 mx-auto">
                <form onSubmit={handleSubmit} className="flex flex-wrap">
                    <div className="p-2 w-1/2">
                        <div className="relative">
                            <label htmlFor="fname" className="leading-7 text-sm font-medium text-344054">First name</label>
                            <input type="text" id="fname" name="fname" placeholder='First Name' onChange={onChange} className="w-full bg-transparent rounded-md border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-sm outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" />
                        </div>
                    </div>
                    <div className="p-2 w-1/2">
                        <div className="relative">
                            <label htmlFor="lname" className="leading-7 text-sm font-medium text-344054">Last name</label>
                            <input type="text" id="lname" name="lname" placeholder='Last Name' onChange={onChange} className="w-full bg-transparent rounded-md border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-sm outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" />
                        </div>
                    </div>
                    <div className="p-2 w-full">
                        <div className="relative">
                            <label htmlFor="email" className="leading-7 text-sm font-medium text-344054">Email</label>
                            <input type="email" id="email" name="email" placeholder='you@company.com' onChange={onChange} className="w-full  bg-transparent rounded-md border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-sm outline-none text-gray-700 py-1 px-3 resize-none leading-8 transition-colors duration-200 ease-in-out" />
                        </div>
                    </div>
                    <div className="p-2 w-full">
                        <div className="relative">
                            <label htmlFor="mobile" className="leading-7 text-sm font-medium text-344054">Phone number</label>
                            <input type="number" id="mobile" name="number" maxLength={10} onInput={maxLengthCheck} placeholder='+1(555) 000-0000' onChange={onChange} className="w-full  bg-transparent rounded-md border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-sm outline-none text-gray-700 py-1 px-3 resize-none leading-8 transition-colors duration-200 ease-in-out" />
                        </div>
                    </div>
                    <div className="p-2 w-full">
                        <div className="relative">
                            <label htmlFor="message" className="leading-7 text-sm font-medium text-344054">Message</label>
                            <textarea id="message" name="message" onChange={onChange} className="w-full  bg-transparent rounded-md border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out" ></textarea>
                        </div>
                    </div>
                    <div className="p-2 w-full">
                        <div className="relative inline-flex items-center">
                            <input type="checkbox" id="privacy" name="privacy" placeholder='First Name' className="w-max bg-transparent rounded-md border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-sm outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" required />
                            <label htmlFor="privacy" className="leading-7 ml-2 text-sm font-medium text-667085">You agree to our friendly privacy policy.</label>
                        </div>
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey="6LesC3kgAAAAADxfDRvDyxJ7-4Z4ml8i0f37NeZx"
                            onChange={onChange}
                            className='my-3'
                        />
                    </div>
                    <div className="p-2 w-full">
                        <button className="inline-flex justify-center items-center bg-088AB2 border-0 py-2 px-4 w-full focus:outline-none justify hover:bg-gray-200 rounded-md text-white hover:text-088AB2 mt-4 md:mt-0">Send message</button>
                    </div>
                </form>
            </div>
        </div>
    </section>
    </>
  )
}

export default Contact